import AIChat from './AIChat';
export default AIChat;